import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { LegacyDeviceWebhook } from 'types/legacyDashboard';

export interface DeviceWebhookResult {
  success: true;
  data: LegacyDeviceWebhook;
}

export interface DeviceWebhookResultError {
  info: { success: boolean; error: string };
  status: number;
}

const useDeviceWebhook = (deviceId?: DeviceId, orgId?: OrgId) => {
  const url = deviceId
    ? `${process.env.VITE_API_ROOT}/devices/${deviceId}/webhook?orgid=${orgId ?? ''}`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    DeviceWebhookResult,
    DeviceWebhookResultError
  >(url, getFetcher);

  const deviceWebhook: Partial<LegacyDeviceWebhook> = useMemo(() => data?.data ?? {}, [data]);

  // This endpoint returns 400 bad request when no webhook exists
  if (
    error?.status === 400 &&
    error?.info?.error === 'Invalid DeviceWebhooks or unable to access'
  ) {
    return {
      deviceWebhook,
      error: null,
      isLoading,
      isValidating,
      mutate,
    };
  }

  return {
    deviceWebhook,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useDeviceWebhook;
